import { render } from "./FDetail.vue?vue&type=template&id=190af165"
import script from "./FDetail.vue?vue&type=script&lang=js"
export * from "./FDetail.vue?vue&type=script&lang=js"

import "./FDetail.vue?vue&type=style&index=0&id=190af165&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__